import { FC } from 'react';
import { Divider, Stack } from '@mui/material';
import useCountdown from '~/utils/useCountdown';

import { useStoreState } from '~/store/hooks';
import { MfaType } from '~/services/api/enums';

import styles from './ResendCode.module.scss';
import { MFA_LABELS } from './constants';

interface IProps {
  onResendCode: (mfaTypeId: MfaType) => Promise<void>;
}

const ResendCode: FC<IProps> = ({ onResendCode }) => {
  const { seconds, isActive, restart } = useCountdown(60);

  const { mfaTypeId, availableMfaTypes } = useStoreState(store => store.auth.mfaRequired);

  const resendCode = async (typeId: MfaType) => {
    if (isActive) {
      return;
    }

    await onResendCode(typeId);

    restart();
  };

  if (isActive) {
    return (
      <div className={styles.textRow}>
        {MFA_LABELS[mfaTypeId]} sent. Another resend will be available in {seconds} seconds.
      </div>
    );
  }

  return (
    <div className={styles.row}>
      <div className={styles.textRow}>Haven&apos;t received your code yet?</div>

      <Stack
        direction="row"
        display="flex"
        justifyContent="center"
        divider={
          <Divider orientation="vertical" flexItem sx={{ borderColor: 'black', opacity: 1 }} />
        }
        spacing={1}
      >
        {availableMfaTypes.map(mfaType => (
          <span
            key={mfaType}
            role="button"
            className={styles.resendCode}
            onClick={() => resendCode(mfaType)}
            onKeyPress={() => resendCode(mfaType)}
            tabIndex={0}
          >
            Resend by {MFA_LABELS[mfaType]}
          </span>
        ))}
      </Stack>
    </div>
  );
};

export default ResendCode;
